<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const ParagraphDefaults = {
        "name": "paragraph",
        "text": {
            "name": "text",
            "style": {},
            "innerText": "This is a paragraph"
        },
        "meta": {
            "order": {
                "text": 0
            }
        }
    }
    
</script>

<script>

</script>

<p data-i-name="text"/>
<!-- <button on:click="{alert('test')}"> test </button> -->

<style>

</style>